import { Workbook } from 'exceljs'
import { formatShmpCourse } from '@/lib/shmpCourse'
import type { ShmpDashboardData, ShmpPartnerMetrics } from '@/types'

function download(buffer: BlobPart, filename: string, type: string) {
  const url = URL.createObjectURL(new Blob([buffer], { type }))
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

const partnerHeaders = [
  'Франчайзи', 'ФИО', 'Города', 'Курс', 'Студии', 'Выручка', 'План',
  '% плана', 'Заявки', 'Записи', 'CR1', 'Приходы', 'CR2', 'Продажи',
  'CR3', 'Средний чек', 'Возвраты', 'Рост к прошлому периоду',
]

function partnerValues(row: ShmpPartnerMetrics): Array<string | number | null> {
  return [
    row.partner_number, row.persons_fio, row.cities_text,
    formatShmpCourse(row.course_numbers, row.course_number),
    row.studio_count, row.revenue_fact, row.revenue_plan, row.plan_completion_pct,
    row.leads_fact, row.appointments_fact, row.cr1, row.visitors_fact, row.cr2,
    row.sales_fact, row.cr3, row.average_check, row.refunds_fact, row.revenue_growth_pct,
  ]
}

export async function exportShmpXlsx(data: ShmpDashboardData, partners: ShmpPartnerMetrics[], filename: string) {
  const workbook = new Workbook()
  const summary = workbook.addWorksheet('Сводка')
  summary.addRows([
    ['Показатель', 'Значение'],
    ['План', data.summary.revenue_plan],
    ['Факт', data.summary.revenue_fact],
    ['Выполнение, %', data.summary.plan_completion_pct],
    ['Заявки', data.summary.leads_fact],
    ['Записи', data.summary.appointments_fact],
    ['Приходы', data.summary.visitors_fact],
    ['Продажи', data.summary.sales_fact],
    ['Средний чек', data.summary.average_check],
    ['Возвраты', data.summary.refunds_fact],
  ])

  const courses = workbook.addWorksheet('Курсы')
  courses.addRow(['Курс', 'Франчайзи', 'Студии', 'План', 'Факт', '% плана'])
  data.courses.forEach(row => courses.addRow([
    row.course_number, row.partner_count, row.studio_count,
    row.revenue_plan, row.revenue_fact, row.plan_completion_pct,
  ]))

  const franchisees = workbook.addWorksheet('Франчайзи')
  franchisees.addRow(partnerHeaders)
  partners.forEach(row => franchisees.addRow(partnerValues(row)))

  for (const sheet of workbook.worksheets) {
    sheet.getRow(1).font = { bold: true }
    sheet.columns.forEach(column => { column.width = 18 })
  }

  const buffer = await workbook.xlsx.writeBuffer()
  download(buffer, `${filename}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
}

export function exportShmpCsv(partners: ShmpPartnerMetrics[], filename: string) {
  const escape = (value: string | number | null) => `"${String(value ?? '').replace(/"/g, '""')}"`
  const rows = [partnerHeaders, ...partners.map(partnerValues)]
  const csv = `\uFEFF${rows.map(row => row.map(escape).join(';')).join('\r\n')}`
  download(csv, `${filename}.csv`, 'text/csv;charset=utf-8')
}
